import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-reporte-justificativa-dialog',
  template: `
    <h2 mat-dialog-title>Reportar identificação do candidato</h2>
    <mat-dialog-content>
      <p>Ao confirmar, o envelope ficará bloqueado até a decisão do presidente da comissão.</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Motivo da suspeita</mat-label>
        <textarea matInput [(ngModel)]="justificativa" rows="3"
          placeholder="Ex: Nome visível na página 2, assinatura na margem..."
          style="resize: none;"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="cancelar()">Cancelar</button>
      <button mat-flat-button color="warn" [disabled]="!justificativa.trim()" (click)="confirmar()">
        Confirmar Reporte
      </button>
    </mat-dialog-actions>
  `,
  styles: ['.full-width { width: 100%; }']
})
export class ReporteJustificativaDialogComponent {
  justificativa = ''

  constructor(public dialogRef: MatDialogRef<ReporteJustificativaDialogComponent>) {}

  confirmar(): void {
    this.dialogRef.close(this.justificativa.trim())
  }

  cancelar(): void {
    this.dialogRef.close(null)
  }
}
